/// <reference path='../_all.ts' />


module menuEditor {
  /**
   * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
   */
  export class menueditorService {
    static $inject = [
      '$http',
    ];

    constructor(
      // Add the parameter and type definition.
      public $http: ng.IHttpService
    ) { }

    public getBusinessAreaList(): ng.IHttpPromise<BusinessArea[]> {

      return this.$http<BusinessArea[]>({
        method: "GET"
        , url: "/api/D/Navigation/MeasuringTable"
        , headers: { 'Content-Type': 'application/json' }
      }).then((response: { data: BusinessArea[] }) : any => { //success
        return response;
      });

    }

    public saveBusinessAreaList(bas: BusinessArea[]): ng.IHttpPromise<BusinessArea[]> {

      return this.$http<BusinessArea[]>({
        method: "PUT"
        , url: "/api/D/Navigation/SaveMeasuringTable"
        , data: bas
        , headers: { 'Content-Type': 'application/json' }
      }).then((response: { data: BusinessArea[] }) : any => {
        return response;
      });
    }

  }

}
